var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilteMixer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.31833 23.5467V15.4325H3V13.1142H9.955V15.4325H7.63667V23.5467H5.31833ZM5.31833 10.7958V5H7.63667V10.7958H5.31833ZM9.955 10.7958V8.4775H12.2733V5H14.5917V8.4775H16.91V10.7958H9.955ZM12.2733 23.5467V13.1142H14.5917V23.5467H12.2733ZM19.2283 23.5467V20.0692H16.91V17.7508H23.865V20.0692H21.5467V23.5467H19.2283ZM19.2283 15.4325V5H21.5467V15.4325H19.2283Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilteMixer);
export default __webpack_public_path__ + "static/media/filteMixer.b237d1060a67ae798fce1d71d9f172e5.svg";
export { ForwardRef as ReactComponent };